/** What players call the ring game a full trail or full side lights start
 *  (producer 2026-10-14: "Wheel Run", was "Lamp Run"), and a slot's first,
 *  bomb-free one. Use these, never the words, in anything players see. In a
 *  module of their own so the friends' lines can use them without a cycle
 *  (road.ts re-exports friends.ts). */
export const RUN_NAME = 'Wheel Run';
export const LUCKY_RUN_NAME = 'Lucky Run';
